import data from './data';
import Card from './Card';

const CardResumList = ({ numOfTab = '1' }) => {
  return (
    <>
      {data[numOfTab].map((item) => (
        <Card key={item.id} data={item} />
      ))}
    </>
  );
};

export default CardResumList;
